export enum Furnishing {
  SIMPLE = 'SIMPLE',
  NORMAL = 'NORMAL',
  HIGH_QUALITY = 'HIGH_QUALITY',
  LUXURIOUS = 'LUXURIOUS',
}
